module.exports = __webpack_public_path__ + "static/media/8.b0f6def3.mp3";